import Link from "next/link";
import React from "react";
import Application from "./Application";

const TeamApplicationsSent = ({
  loadingApplication,
  hasSentApps,
  teamApplications,
}) => {
  if (loadingApplication) {
    return (
      <section className="container--dashboard_section invites_section">
        <h2 className="header header-left">Teams you applied to</h2>
        <div className="container--invites invites_sent">
          <p>LoadingApplication applications...</p>
        </div>
      </section>
    );
  } else {
    return (
      <section className="container--dashboard_section invites_section">
        {hasSentApps && (
          <>
            <div className="container--invites invites_sent">
              {teamApplications.map((theApplication) => (
                  <Link
                    style={{cursor:'pointer'}}
                    href={"publicteam/"+theApplication?.Team?.public_team_id}
                    legacyBehavior
                    aria-label="Go to Team"
                    > 
              <div style={{cursor:'pointer'}} >
              <Application
                  key={`Sent${theApplication.Team.public_team_id}${theApplication.id}`}
                  appData={theApplication}
                  appType="sent"
                />
                </div>
                </Link>
              ))}
            </div>
          </>
        )}
        {!hasSentApps && (
          <h2 className="header header--section_title header-left">
            You have not applied to any groups
          </h2>
        )}
      </section>
    );
  }
};

export default TeamApplicationsSent;
